// Per-truck route colors for the map (polylines + markers): one color per truck.
// The palette is intentionally local to keep Wave 1 free of any Admin/Geo imports
// (the shared extraction happens in Wave 2). Values mirror the design mockup's
// driver palette — distinct hues that stay legible on the muted map background.
const TRUCK_REPLAY_PALETTE = [
  '#0074DF',
  '#00A11A',
  '#9B51E0',
  '#FF7A00',
  '#1FB6C1',
  '#C2185B',
  '#5E6AD2',
  '#E5B800',
] as const;

/** Color for the truck at `index` in the (stable) truck ordering; wraps the palette. */
export function getReplayTruckColor(index: number) {
  return TRUCK_REPLAY_PALETTE[index % TRUCK_REPLAY_PALETTE.length];
}
